import { render } from "./GlitchP.vue?vue&type=template&id=5b7f551e&scoped=true&ts=true"
import script from "./GlitchP.vue?vue&type=script&lang=ts"
export * from "./GlitchP.vue?vue&type=script&lang=ts"

import "./GlitchP.vue?vue&type=style&index=0&id=5b7f551e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b7f551e"]])

export default __exports__